<template>
  <div 
    class="navbar-collapse"
    :class="{ 'show': isOpen || isDesktop }"
  >
    <ul class="navbar-nav">
      <slot name="pages"></slot>
      <li class="nav-separator"></li>
      <slot name="actions"></slot>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'NavMenu',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    isDesktop: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
  gap: 0.75rem;
  width: 100%;
}

.nav-separator {
  flex-shrink: 0;
}

/* Desktop separator - linea verticale */
@media (min-width: 992px) {
  .nav-separator {
    width: 1px;
    height: 24px;
    background-color: rgba(255, 255, 255, 0.2);
    margin: 0 0.75rem;
    display: block;
  }
}

/* Desktop styles */
@media (min-width: 992px) {
  .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
    flex-grow: 0;
    justify-content: flex-end;
    margin-left: auto;
  }

  .navbar-nav {
    flex-direction: row;
    align-items: center;
    gap: 0.75rem;
    width: auto;
    margin-left: 0;
  }
}

/* Mobile menu overlay */
@media (max-width: 991.98px) {
  .navbar-collapse {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(42, 82, 152, 0.98), rgba(30, 60, 114, 0.98));
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    padding: 6rem 2rem 2rem;
    margin: 0;
    overflow-y: auto;
    z-index: 1050;
    transform: translateX(-100%);
    transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .navbar-collapse.show {
    transform: translateX(0);
  }

  .navbar-nav {
    gap: 1rem;
    max-width: 100%;
  }

  /* Mobile separator - linea orizzontale */
  .nav-separator {
    width: 100%;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.15), transparent);
    margin: 0.5rem 0;
    display: block;
  }
}
</style>

